export default {
    namespaced: true,
    state: () => ({
        UserLoged: {
            username: "admin@email.com",
            password: "Admin",
            PhotoProfile: "https://randomuser.me/api/portraits/men/51.jpg",
            name: "Carlos Alberto Rodríguez",
            companyName: "Pampa Energy",
            telephone: "+54 9 1131771755",
            email:"carlos.rodriguez@pampaenergy.au"
        },
        ArrayUsers: [{
            username: "admin@email.com",
            password: "Admin",
            PhotoProfile: "https://randomuser.me/api/portraits/men/51.jpg",
            name: "Carlos Alberto Rodríguez",
            companyName: "Pampa Energy",
            telephone: "+54 9 1131771755",
            email:"carlos.rodriguez@pampaenergy.au"
        }]
    }),
    mutations: {
        SetUserLoged(state, dataUser) {
            state.UserLoged = dataUser
        }
    },
    actions: {
        Login({ commit, getters }, { username, password }) {
            const SearchUser = getters.findUser(username)
            if (SearchUser && SearchUser.password === password) {
                commit('SetUserLoged', SearchUser)
                localStorage.setItem("SesionToken", SearchUser)
                return true
            }
            return false
        },
        LogOut(
            // { commit }
        ) {
            // commit('SetUserLoged', undefined)
            localStorage.removeItem('SesionToken')
        }
    },
    getters: {
        getUserLoged: state => {
            return state.UserLoged
        },
        findUser: (state) => (username) => {
            return state.ArrayUsers.find(user => user.username === username)
        }
    }
}